import { z } from 'zod';
import { pipelineZod } from 'packages/lib/api/annotations/contract/enums';

export const lidarExtractionZod = z.object({
  token: z.string(),
  name: z.string(),
  sampleGroupToken: z.string(),
  logToken: z.nullable(z.string()),
  startTimestamp: z.number().int().nonnegative(),
  endTimestamp: z.number().int().nonnegative(),
  hz: z.nullable(z.number().int()),
  attachmentTokens: z.nullable(z.string()),
  properties: z.nullable(z.string()),
  tag: z.nullable(z.string()),
  owner: z.nullable(z.string()),
  description: z.nullable(z.string()),
  comments: z.nullable(z.string()),
  badLocalization: z.boolean(),
  pipeline: pipelineZod,
  pipelineToken: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  lastAnnotatedAt: z.nullable(z.string().datetime()),
});

export type LidarExtraction = z.infer<typeof lidarExtractionZod>;
